import { render } from "./close-button.vue?vue&type=template&id=3160b5ef&scoped=true"
import script from "./close-button.vue?vue&type=script&lang=js"
export * from "./close-button.vue?vue&type=script&lang=js"

import "./close-button.vue?vue&type=style&index=0&id=3160b5ef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3160b5ef"]])

export default __exports__